/*
const mediaGalleryEntries = useMemo(
        () => getMediaGalleryEntries(product, optionCodes, optionSelections),
        [product, optionCodes, optionSelections]
    )


                let media = mediaGalleryEntries && mediaGalleryEntries[0]
                // 默认展示图片position最小的
                mediaGalleryEntries &&
                    mediaGalleryEntries.forEach((item, index) => {
                        if (item.position < media.position) {
                            media = item
                        }
                    })

                product_image =
                    process.env.NEXT_PUBLIC_MAGENTO_BACKEND_URL +
                    generateUrl(
                        mediaGalleryEntries && media?.file,
                        'image-product'
                    )(90, 132)

*/

import { findMatchingVariant } from "@/util/findMatchingProductVariant"
import { generateUrl } from "@/util/imageUtils"
import { isProductConfigurable } from "@/util/isProductConfigurable"

export const getMediaGalleryEntries = (
  product,
  optionCodes,
  optionSelections
) => {
  let value = []

  const { media_gallery_entries, variants } = product || {}
  const isConfigurable = isProductConfigurable(product)

  // Selections are initialized to "code => undefined". Once we select a value, like color, the selections change. This filters out unselected options.
  const optionsSelected =
    Array.from(optionSelections.values()).filter((value) => !!value).length > 0

  if (!isConfigurable || !optionsSelected) {
    value = media_gallery_entries
  } else {
    // If any of the possible variants matches the selection add that
    // variant's image to the media gallery. NOTE: This _can_, and does,
    // include variants such as size. If Magento is configured to display
    // an image for a size attribute, it will render that image.
    const item = findMatchingVariant({
      optionCodes,
      optionSelections,
      variants,
    })

    value =
      item && item.product && item.product.media_gallery_entries
        ? [...item.product.media_gallery_entries]
        : media_gallery_entries
  }

  value.forEach((temp) => {
    temp.image = temp.url
    temp.thumbnail = temp.url
  })

  return value
}

// 获得加车单张图片
export const getSingleImage = (mediaGalleryEntries) => {
  let media = mediaGalleryEntries && mediaGalleryEntries[0]

  // 默认展示图片position最小的
  mediaGalleryEntries &&
    mediaGalleryEntries.forEach((item, index) => {
      if (item.position < media.position) {
        media = item
      }
    })

  const product_image =
    process.env.NEXT_PUBLIC_MAGENTO_BACKEND_URL +
    generateUrl(mediaGalleryEntries && media?.file, "image-product")(90, 132)

  return product_image
}
